import React from 'react'
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function ErrorPage() {
  let navigate = useNavigate();
  useEffect(() => {
   
    navigate('/');
 });

 const getHomeRoute = () => {
  const country = localStorage.getItem("selectedCountryCode");

  const countryRoutes = {
    AE: "/AE",
    SA: "/SA",
    QA: "/QA",
    BH: "/BH",
    OM: "/OM",
    KW: "/KW",
  };

  return countryRoutes[country] || "/";
};
  
  return (
    <div>
  <div>
  <div classname="lock">
    <div classname="message">
      <h1>Access to this page is restricted</h1>
      <Link to={getHomeRoute()}> Goto Home</Link>
      {/* <p>Please check with the site admin if you believe this is a mistake.</p> */}
    </div>
  </div>
</div>

    </div>
  )
}

export default ErrorPage
